export default __webpack_public_path__ + "static/media/19.cdd7c103.jpg";